import axios from 'axios'
import queryString from 'query-string'
import { CreditCardListResponse } from 'src/models/creditCard.models'
import { CreditCardPermissionsResponse } from 'src/models/creditCardPermissions.models'
import { PaginationResponse } from 'src/models/pagination.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { GetCreditCardsRequest } from 'src/requests/getCreditCards.request'

export interface CreditCardsResponse {
  pagination: PaginationResponse
  creditCards: CreditCardListResponse[]
}

// Pure network functions for the credit-card query family. URLs are preserved
// byte-for-byte from the legacy useExtendQuery call sites (note: detail /
// permissions use a leading slash, the list endpoints do not — axios resolves
// both against the configured baseURL). getRequestConfig(RequestConfig.Default)
// returns the same authed-json request config the legacy useRequestConfig hook
// pulled from redux, and getResponseData throws a normalized QueryError that
// carries the raw AxiosError on the non-enumerable `originalError` property.

export const getCreditCard = async (
  creditCardId: string,
): Promise<{ creditCard: CreditCardListResponse }> =>
  getResponseData(
    axios.get<{ creditCard: CreditCardListResponse }>(
      `/creditcards/${creditCardId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getCreditCardPermissions = async (
  creditCardId: string,
): Promise<CreditCardPermissionsResponse> =>
  getResponseData(
    axios.get<CreditCardPermissionsResponse>(
      `/creditcards/${creditCardId}/permissions`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getCreditCards = async (
  filters: GetCreditCardsRequest,
  page: number,
): Promise<CreditCardsResponse> =>
  getResponseData(
    axios.get<CreditCardsResponse>(
      `creditcards?${queryString.stringify({ ...filters, page })}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getCreditCardsPaginated = async (
  filters: GetCreditCardsRequest,
): Promise<CreditCardsResponse> =>
  getResponseData(
    axios.get<CreditCardsResponse>(
      `creditcards?${queryString.stringify({ ...filters })}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
